import get from "lodash/get"

const styles = theme => ({
    textfieldWrapper: {
        marginBottom: "8px",
        position: "relative",
    },

    hasError: {
        backgroundColor: theme.palette.error.main,
        borderRadius: get(theme, "appicalTheme.borderRadius"),
    },

    errorContainer: {
        color: theme.palette.primary.contrastText,
        minHeight: "19px",
        padding: "0 0 0 12px",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: theme.palette.error.main,
        borderRadius: get(theme, "appicalTheme.borderRadius"),
        "& a": {
            color: "inherit",
            textDecoration: "none",
            "&:hover": {
                textDecoration: "underline",
            },
        },
    },

    textField: {
        height: "40px",
        width: "100%",
        margin: "0px",
        padding: "4px 12px",
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "rgba(0, 0, 0, 0.1)",
        borderRadius: get(theme, "appicalTheme.borderRadius"),
        color: theme.typography.body1.color,
        fontSize: theme.typography.body1.fontSize,
        fontWeight: theme.typography.body1.fontWeight,
        lineHeight: theme.typography.body1.lineHeight,
        outline: "none",

        "&::placeholder": {
            color: get(theme, "appicalTheme.black35"),
        },

        "&:focus-visible": {
            borderColor: "rgba(0, 106, 255, 1)"
        },
    },

    active: {
        borderColor: "rgba(0, 0, 0, 0.7)",
    },

    error: {
        borderColor: theme.palette.error.main,
    },

    inputIcon: {
        color: get(theme, "appicalTheme.black"),
        position: "absolute",
        right: 0,
        top: 0,
        padding: get(theme, "appicalTheme.spacing.gap"),

        "&:focus-visible": {
            outlineColor: "rgba(1, 84, 192, 1)",
            outlineWidth: "1px",
            outlineStyle: "solid",
            outlineOffset: "-4px"
        }
    },

    label: {
        fontSize: "16px",
        color: get(theme, "appicalTheme.labelColor"),
        marginBottom: get(theme, "appicalTheme.spacing.gap"),
    },

    link: {
        color: "#0000EE !important",
    },
})

export default styles
